const hoverableLogos = page => {
  page.querySelectorAll('[data-hoverable-logos-wrapper]').forEach(wrapper => {
    const bg = wrapper.querySelector('[data-hoverable-logos-bg]')
    const logos = wrapper.querySelectorAll('[data-hoverable-logos-logo]')
    logos.forEach(logo => {
      logo.addEventListener('mouseenter', () => {
        bg.style.backgroundImage = `url(${logo.dataset.bgSrc})`
      })
    })
  })
}

export default hoverableLogos
